module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearcache"
  }, [_vm._v("\n  " + _vm._s(_vm.status) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a846e0c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clearcache/component.vue
// module id = 3692
// module chunks = 1